module.exports = __webpack_public_path__ + "static/media/secondWitnessLogo.92c055b3.webp";